"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "urbisaglia": {
    "6ad1a1b0": [{
      "hkey": "82f29f7a",
      "slug": "abbadia-di-fiastra",
      "name": "Abbadia di Fiastra",
      "primary": true,
      "skipSearch": false
    }],
    "centri-abitati-abbadia-di-fiastra": [{
      "hkey": "82f29f7a",
      "slug": "abbadia-di-fiastra",
      "name": "Abbadia di Fiastra",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bf0846f2": [{
      "hkey": "2ee38fe5",
      "slug": "urbisaglia",
      "name": "Urbisaglia",
      "primary": true,
      "skipSearch": false
    }],
    "colli-vasari": [{
      "hkey": "2ee38fe5",
      "slug": "urbisaglia",
      "name": "Urbisaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c1e6f78c": [{
      "hkey": "2ee38fe5",
      "slug": "urbisaglia",
      "name": "Urbisaglia",
      "primary": true,
      "skipSearch": false
    }],
    "fiastra": [{
      "hkey": "2ee38fe5",
      "slug": "urbisaglia",
      "name": "Urbisaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "33212a56": [{
      "hkey": "2ee38fe5",
      "slug": "urbisaglia",
      "name": "Urbisaglia",
      "primary": true,
      "skipSearch": false
    }],
    "pezzalunga": [{
      "hkey": "2ee38fe5",
      "slug": "urbisaglia",
      "name": "Urbisaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "69d38c4e": [{
      "hkey": "2ee38fe5",
      "slug": "urbisaglia",
      "name": "Urbisaglia",
      "primary": true,
      "skipSearch": false
    }],
    "selva": [{
      "hkey": "2ee38fe5",
      "slug": "urbisaglia",
      "name": "Urbisaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7cbd2868": [{
      "hkey": "2ee38fe5",
      "slug": "urbisaglia",
      "name": "Urbisaglia",
      "primary": true,
      "skipSearch": false
    }],
    "valleresco": [{
      "hkey": "2ee38fe5",
      "slug": "urbisaglia",
      "name": "Urbisaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4fccd7e9": [{
      "hkey": "2ee38fe5",
      "slug": "urbisaglia",
      "name": "Urbisaglia",
      "primary": true,
      "skipSearch": false
    }],
    "villamagna": [{
      "hkey": "2ee38fe5",
      "slug": "urbisaglia",
      "name": "Urbisaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;